"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _fp = require("lodash/fp");
var getOfferTypes = function(offer) {
    return (0, _fp.flow)((0, _fp.get)('offerTypes'), (0, _fp.map)('identifier.current'), _fp.compact)(offer);
};
var _default = getOfferTypes;
